




import type { PropType } from '@vue/composition-api';
import { defineComponent, computed } from '@vue/composition-api';
import type { Field } from '../types/field';

export default defineComponent({
  props: {
    field: {
      type: Object as PropType<Field>,
      required: true,
    },
  },
  setup(props) {
    const value = computed(() => props.field.value || props.field.label || '');

    return {
      value,
    };
  },
});
